export default __webpack_public_path__ + "static/media/chevrons-right-charcoal.31bf2648.svg";